// extracted by mini-css-extract-plugin
module.exports = {"navigation":"footer-module--navigation--1Zz30","text":"footer-module--text--1b_NJ","icon":"footer-module--icon--2vroY"};